import classes from "./AvailableMeals.module.css";
import Card from "../UI/Card";
import MealItem from "../Layout/MealItem/MealItem";

const DUMMY_MEALS = [
  {
    id: "m1",
    name: "Miso Chashu Pork ramen",
    description: "Served with chasu pork,bean sprouts",
    price: 22.99,
  },
  {
    id: "m2",
    name: "Fish Cutlet with Rice",
    description: "Limited eidtion Item",
    price: 16.5,
  },
  {
    id: "m3",
    name: "Beef Fried Rice",
    description: "Made with Mouthwatering stuff",
    price: 12.99,
  },
  {
    id: "m4",
    name: "Green Bowl",
    description: "Healthy...and green...",
    price: 18.99,
  },
];

const AvalilableMeals = () => {
  const mealsList = DUMMY_MEALS.map((meal) => (
    <MealItem
      key={meal.id}
      id={meal.id} // this is new!
      name={meal.name}
      description={meal.description}
      price={meal.price}
    />
  ));

  return (
    <section className={classes.meals}>
      <Card>
        <ul>{mealsList}</ul>
      </Card>
    </section>
  );
};

export default AvalilableMeals;
